var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"location-finder-app"}},[((Object.keys(_vm.locationsJson).length > 0))?_c('LocationsMapBox',{attrs:{"locationsJson":_vm.locationsJson,"getSingleLocation":_vm.getSingleLocation},on:{"isLoaded":_vm.isLoaded}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }